module.exports = __webpack_public_path__ + "static/media/program-learn-main-5.034ebd8f.png";